import React, { FunctionComponent, ReactText } from 'react';

import { ListDropdown, ListOption } from '@components/library/dropdown/index';
import { CustomFieldKeyValuesEntry, CustomFieldPayloadOperations } from '@components/asset/modal/tabs/edit/EditTabTypes';

interface SingleValueRestrictedProps {
  currValues: ListOption[];
  dispatchCustomFieldValue: (
    optionValue: ReactText,
    operation: CustomFieldPayloadOperations,
    customFieldValueId?: string
  ) => void;
  existingCustomFieldMap: CustomFieldKeyValuesEntry;
  options: ListOption[];
}

export const SingleValueRestricted: FunctionComponent<SingleValueRestrictedProps> = ({
  currValues,
  dispatchCustomFieldValue,
  existingCustomFieldMap,
  options
}) => (
  <ListDropdown
    onChange={(listOption: ListOption): void => {
      let op = CustomFieldPayloadOperations.Create;
      let customFieldValueId;
      if (existingCustomFieldMap?.customFieldValues.length > 0) {
        op = CustomFieldPayloadOperations.Update;
        customFieldValueId = existingCustomFieldMap?.customFieldValues[0].key;
      }
      dispatchCustomFieldValue(listOption.value, op, customFieldValueId);
    }}
    options={options}
    placeholder={bfTranslate("Select value")}
    searchable
    value={currValues && currValues.length > 0 ? currValues[0] : undefined}
  />
);
